import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RadioChoiceComponent } from './RadioChoice.component';

export const RadioChoiceModuleExports = [RadioChoiceComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...RadioChoiceModuleExports],
    exports: [...RadioChoiceModuleExports],
    providers: []
})
export class RadioChoiceModule {}
